import { createQueryKeySet } from '~/utils/query-keys';
import { useQuery } from '@tanstack/react-query';
import { SSF } from '~/apis/api';

export const keys = createQueryKeySet<{ id: number }>('competitions.export');

export function useCompetitionExportRegistrationsQuery(id: number, enabled = false) {
  return useQuery({
    queryFn: async () => {
      const { data } = await SSF.api.competitionsExportRegistrationsRetrieve(id);
      return data;
    },
    queryKey: keys.detail(id),
    enabled,
  });
}
